import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';
import ModalConfirm from '../components/modal/modalConfirm';

import hardwareIcon from 'src/images/icons/hardware.svg';
import virtualIcon from 'src/images/icons/virtual.svg';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const linkToProposition = '/dashboard/proposal/';
const linkToOrderForm = '/dashboard/orderform/';
const linkToDossier = '/dashboard/dossier/';
const linkToProductHardware = '/dashboard/productHardware/';
const linkToProductVirtual = '/dashboard/productVirtual/';
const apiUpdateBilling = '/api/stepAdministrative/updateBilling/';

class AppBilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      selectedView: 1,
      isModalBilledOpen: false,
      productToBillId: undefined,
      textModal: {
        title: undefined,
        message: undefined,
      },
      isModalDeleteOpen: false,
      isVirgin: false,
      isFinished: false, // if finished -> no need for the "Bill All" button
      accordionMenu: new Object(),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.markAsBilled = this.markAsBilled.bind(this);
    this.markAllBilled = this.markAllBilled.bind(this);
    this.markOneBilled = this.markOneBilled.bind(this);
    this.refreshAssociations = this.refreshAssociations.bind(this);
    this.checkVirgin = this.checkVirgin.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      this.refreshAssociations();
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  refreshAssociations() {
    const paramsID = this.props.match.params.id;

    let queryURL = apiDealShow;
    let graphQL =
      '{ deal(id:' +
      paramsID +
      '){ id, ' +
      'stepProd { id, intermediateStageNumber, preparation{ ' +
      'associationsProductsHardware{ id, products{ id, installed, billed, stickerId }, quoteArticle{ id, quantity, productReference{ id, wording, supplierHardware{ name, url } } } },' +
      'associationsProductsVirtual{ id, products{ id, installed, billed }, quoteArticle{ id, quantity, productReference{ id, wording, supplierVirtual{ name, url } } } },' +
      ' } } ' +
      '} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deal']['stepProd']['preparation']) {
            this.checkVirgin(
              data['data']['deal']['stepProd']['preparation']['associationsProductsHardware'],
              data['data']['deal']['stepProd']['preparation']['associationsProductsVirtual']
            ),
              this.setState({
                dealID: data['data']['deal']['id'],
                dataAssociationHardware:
                  data['data']['deal']['stepProd']['preparation']['associationsProductsHardware'],
                dataAssociationVirtual: data['data']['deal']['stepProd']['preparation']['associationsProductsVirtual'],
              });
          }
          //console.log(data);
        }.bind(this)
      )
      .catch((error) => {
        console.log('erreur fetch deal entity: \n' + error);
      });
  }

  checkVirgin(associationsHardware, associationsVirtual) {
    let virgin = true;
    let finished = true;
    for (let i = 0; i < associationsHardware.length; i++) {
      for (let j = 0; j < associationsHardware[i].products.length; j++) {
        if (associationsHardware[i].products[j].billed) {
          virgin = false;
        } else {
          finished = false;
        }
      }
    }

    if (virgin || finished)
      for (let i = 0; i < associationsVirtual.length; i++) {
        for (let j = 0; j < associationsVirtual[i].products.length; j++) {
          if (associationsVirtual[i].products[j].billed) {
            virgin = false;
          } else {
            finished = false;
          }
        }
      }

    this.setState({
      isVirgin: virgin,
      isFinished: finished,
    });
  }

  toggleAccordion(id) {
    let accordionMenu = { ...this.state.accordionMenu };
    accordionMenu[id] = !accordionMenu[id];
    this.setState({ accordionMenu });
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  isBilled(products) {
    let res = true;

    for (let i = 0; i < products.length; i++) {
      if (!products[i].billed) {
        res = false;
        break;
      }
    }

    return res;
  }

  render() {
    const { dataAssociationHardware } = this.state;
    const { dataAssociationVirtual } = this.state;

    let noQuoteHardware = '';
    let noQuoteVirtual = '';
    if (this.state.dataAssociationHardware != undefined && this.state.dataAssociationHardware.length == 0) {
      noQuoteHardware = <span>Aucun produit pour cette affaire.</span>;
    }
    if (this.state.dataAssociationVirtual != undefined && this.state.dataAssociationVirtual.length == 0) {
      noQuoteVirtual = <span>Aucun abonnement pour cette affaire.</span>;
    }

    const styles = {
      image: {
        width: '15px',
      },
    };

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Produit';
        break;
      case 2:
        viewName = 'Service';
        break;
    }

    return (
      <div id='appView' className='div-entity appSetup'>
        <SubNavBar
          appViewNavExtended={this.state.appViewNavExtended}
          goBack={this.props.history.goBack}
          title='Facturation'
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={() => this.goTo('proposition')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-arrow-right'>Proposition</span>
            </button>
            <button onClick={() => this.goTo('orderform')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-arrow-right'>Bon de commande</span>
            </button>
            <button onClick={() => this.goTo('dossier')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-arrow-right'>Dossier prod</span>
            </button>
          </div>
        </SubNavBar>

        <div id='appViewContent' className='listRefScroll'>
          <div className='timeline menu'>
            <div className='timeline-flex'>
              <div
                onClick={(newStep) => this.switchView(1)}
                className={'prep-step-number ' + (this.state.selectedView == 1 ? 'selected' : '')}
              >
                <img style={styles.image} src={hardwareIcon} />
              </div>
              <div
                onClick={(newStep) => this.switchView(2)}
                className={'prep-step-number ' + (this.state.selectedView == 2 ? 'selected' : '')}
              >
                <img style={styles.image} src={virtualIcon} />
              </div>
            </div>
          </div>
          <div className='timeline-step-name'>
            <h3>{viewName}</h3>
          </div>

          {(this.state.selectedView == 1 || this.state.selectedView == 2) && (
            <div className='helper helper-panel-legend'>
              <span className='helper-label-legend lvl2'>Action requise</span>
              <span className='helper-label-legend lvl1'>En cours</span>
              {!this.state.isFinished ? (
                <button
                  onClick={() => this.openModalBilledState(-1, 'all', true)}
                  type='button'
                  className='btn btn-sm btn-outline-success'
                >
                  <span className='icon icon-check'>Tout facturer</span>
                </button>
              ) : (
                <span className='icon icon-check'>Tout facturé</span>
              )}
            </div>
          )}

          {this.state.selectedView == 1 &&
            (dataAssociationHardware ? (
              dataAssociationHardware.map((data, i) => (
                <div>
                  <li
                    className={
                      'list-group-item entity-row spaced ' + (this.isBilled(data.products) ? '' : 'marked-negative ')
                    }
                    key={data.id}
                  >
                    <button
                      onClick={() => this.toggleAccordion('hardware-' + i)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span
                        className={'icon icon-chevron-' + (this.state.accordionMenu['hardware-' + i] ? 'up ' : 'down ')}
                      ></span>
                    </button>
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.quoteArticle.quantity}</span>
                  </li>
                  {this.state.accordionMenu['hardware-' + i] &&
                    (data.products ? (
                      data.products.map((dataProduct) => (
                        <li
                          className={
                            'list-group-item entity-row indented-1 ' +
                            (dataProduct.installed && !dataProduct.billed ? 'marked-negative ' : '')
                          }
                          key={dataProduct.id}
                        >
                          <Link to={linkToProductHardware + dataProduct.id}>
                            <span>{dataProduct.stickerId}</span>
                          </Link>
                          {dataProduct.installed && !dataProduct.billed && (
                            <button
                              onClick={() => this.openModalBilledState(dataProduct.id, 'hardware')}
                              type='button'
                              className='btn btn-sm btn-outline-success'
                            >
                              <span className='icon icon-check'>Valider</span>
                            </button>
                          )}
                          {dataProduct.billed && <span>Facturé</span>}
                        </li>
                      ))
                    ) : (
                      <li className='list-group-item'>Chargement...</li>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 1 && noQuoteHardware}

          {this.state.selectedView == 2 &&
            (dataAssociationVirtual ? (
              dataAssociationVirtual.map((data, i) => (
                <div>
                  <li
                    className={
                      'list-group-item entity-row spaced ' + (this.isBilled(data.products) ? '' : 'marked-negative ')
                    }
                    key={data.id}
                  >
                    <button
                      onClick={() => this.toggleAccordion('virtual-' + i)}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span
                        className={'icon icon-chevron-' + (this.state.accordionMenu['virtual-' + i] ? 'up ' : 'down ')}
                      ></span>
                    </button>
                    <span>{data.quoteArticle.productReference.wording}</span>
                    <span>{data.quoteArticle.quantity}</span>
                  </li>
                  {this.state.accordionMenu['virtual-' + i] &&
                    (data.quoteArticle.quantity <= itemsPerPage['association_product'] ? (
                      data.products ? (
                        data.products.map((dataProduct) => (
                          <li
                            className={
                              'list-group-item entity-row indented-1 ' +
                              (dataProduct.installed && !dataProduct.billed ? 'marked-negative ' : '')
                            }
                            key={dataProduct.id}
                          >
                            <Link to={linkToProductVirtual + dataProduct.id}>
                              <span>#{dataProduct.id}</span>
                            </Link>
                            {dataProduct.installed && !dataProduct.billed && (
                              <button
                                onClick={() => this.openModalBilledState(dataProduct.id, 'virtual')}
                                type='button'
                                className='btn btn-sm btn-outline-success'
                              >
                                <span className='icon icon-check'>Valider</span>
                              </button>
                            )}
                            {dataProduct.billed && <span>Facturé</span>}
                          </li>
                        ))
                      ) : (
                        <li className='list-group-item'>Chargement...</li>
                      )
                    ) : (
                      <span>
                        Cette article a une quantité supérieure à {itemsPerPage['association_product']} unités.
                      </span>
                    ))}
                </div>
              ))
            ) : (
              <li className='list-group-item'>Chargement...</li>
            ))}
          {this.state.selectedView == 2 && noQuoteVirtual}

          <ModalConfirm
            className='myModal'
            modalText={this.state.textModal}
            isOpen={this.state.isModalBilledOpen}
            onSubmit={this.markAsBilled}
            onClose={this.closeModal}
            onCancel={this.closeModal}
          ></ModalConfirm>
        </div>
      </div>
    );
  }

  openModalBilledState(productId, type, markAll = false) {
    let modal = {
      title: 'Facturation',
      message: 'Vous allez modifiez l\'état en "facturé"',
    };
    this.props.toggleBlackOut();
    this.setState({
      markAll: markAll,
      textModal: modal,
      isModalBilledOpen: true,
      productToBillId: productId,
      productToBillType: type,
    });
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalBilledOpen: false,
    });
  }

  markAsBilled() {
    if (this.state.markAll) {
      this.markAllBilled();
    } else {
      this.markOneBilled();
    }
  }

  markOneBilled() {
    let graphKey = this.state.productToBillType == 'hardware' ? 'productsHardware' : 'productsVirtual';
    let queryURL = apiUpdateBilling;
    let graphQL =
      'mutation { listingProducts(dealId:' +
      this.props.match.params.id +
      ', ' +
      graphKey +
      ':[{id:' +
      this.state.productToBillId +
      ', billed:' +
      true +
      '}]){ ' +
      graphKey +
      '{id, billed} }}';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['listingProducts'][graphKey][0]['billed'] == true) {
            this.refreshAssociations();
            this.props.openToast(true, "L'état de la facturation a été actualisé");
          } else {
            this.props.openToast(false, 'Erreur modification facturation. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur modification facturation. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  markAllBilled() {
    let queryURL = apiUpdateBilling;
    let graphQL =
      'mutation { listingProducts(all:true,dealId:' +
      this.props.match.params.id +
      '){ productsHardware{id, billed}, productsVirtual{ id, billed} } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']) {
            this.refreshAssociations();
            this.props.openToast(true, "L'état de la facturation a été actualisé");
            this.setState({
              isVirgin: false,
              isFinished: true,
            });
          } else {
            this.props.openToast(false, 'Erreur modification facturation. Veuillez réessayer');
          }
        }.bind(this)
      )
      .catch(
        function (rror) {
          this.props.openToast(false, 'Erreur modification facturation. Veuillez réessayer');
          console.log(rror);
        }.bind(this)
      );
  }

  goTo(type) {
    if (this.props.match.params.id) {
      let link = '';
      switch (type) {
        case 'proposition':
          link = linkToProposition;
          break;
        case 'orderform':
          link = linkToOrderForm;
          break;
        case 'dossier':
          link = linkToDossier;
          break;
      }
      this.setState({ extendedNav: false });
      this.props.history.push(link + this.props.match.params.id);
    }
  }

  handleSubmit() {
    //console.log("TODO -> Modal pour confirmer la fin de prep");
    //TODO -> save the prep with fetch
  }

  switchView(newStep) {
    this.setState({
      selectedView: newStep,
    });
    //console.log("step changed => "+newStep);
  }
}

export default withAuth(AppBilling);
